import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import styles from '../styles/components/Gallery.module.css';
import img1 from '../assets/images/img1.png';
import img2 from '../assets/images/img2.png';
import img3 from '../assets/images/img3.png';

function Gallery() {
  const { t } = useTranslation();

  return (
    <section className={styles.gallery}>
      <motion.div
        className={styles.polaroid}
        initial={{ rotate: -6, scale: 0.95, opacity: 0 }}
        animate={{ rotate: -6, scale: 1, opacity: 1 }}
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.4 }}
      >
        <img src={img1} alt={t('gallery.alt1', 'Lampo with girlfriend on dinner')} />
      </motion.div>

      <motion.div
        className={styles.polaroid}
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.4 }}
      >
        <img src={img2} alt={t('gallery.alt2', 'Lampo hiking')} />
      </motion.div>

      <motion.div
        className={styles.polaroid}
        initial={{ rotate: 6, scale: 0.95, opacity: 0 }}
        animate={{ rotate: 6, scale: 1, opacity: 1 }}
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.4 }}
      >
        <img src={img3} alt={t('gallery.alt3', 'Lampo with friends on quads')} />
      </motion.div>
    </section>
  );
}

export default Gallery;
